import React, { Component } from "react";
import { graphql } from "@apollo/react-hoc";
import gql from "graphql-tag";
import tinyColor from "tinycolor2";
import IsOnline from "is-online-component";
import { GenericDialog, ErrorScreen } from "@igloocloud/igloosharedui";
import DialogContent from "@mui/material/DialogContent";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import IconButton from "@mui/material/IconButton";
import Done from "@mui/icons-material/Done";
import Close from "@mui/icons-material/Close";
import LinearProgress from "@mui/material/LinearProgress";
import { CenteredSpinner, getNotchHeight } from "@igloocloud/igloosharedui";
import Igloo, { User, Collection } from "@igloocloud/react-igloo";
import { withTranslation } from "react-i18next";

let dialogContent = null;

export default withTranslation()(
  class PendingTransfer extends Component {
    constructor(props) {
      super(props);

      this.state = {
        hasReceivedOpen: false,
      };
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.open !== this.props.open && nextProps.open) {
        this.setState({ hasReceivedOpen: true });
      }
    }

    render() {
      const { t } = this.props;

      return (
        <Igloo
          server={
            localStorage.getItem("server")
              ? (localStorage.getItem("serverUnsecure") === "true"
                  ? "http://"
                  : "https://") + localStorage.getItem("server")
              : `https://v1.igloo.ooo`
          }
          bearer={
            localStorage.getItem("accountList") &&
            localStorage.getItem("userId") &&
            JSON.parse(localStorage.getItem("accountList")).filter(
              (account) => account.id === localStorage.getItem("userId")
            )[0]
              ? JSON.parse(localStorage.getItem("accountList")).filter(
                  (account) => account.id === localStorage.getItem("userId")
                )[0].token
              : ""
          }
        >
          <GenericDialog
            open={this.props.open}
            close={this.props.close}
            title={t`Pending transfer requests`}
            textButton={t`Close`}
            textButtonFunction={this.props.close}
            noHorizontalPadding
            noDialogContent
          >
            {this.state.hasReceivedOpen && (
              <PendingSharesContent {...this.props} />
            )}
          </GenericDialog>
        </Igloo>
      );
    }
  }
);

const PendingSharesContent = graphql(
  gql`
    query ($limit: NaturalNumber!, $offset: NaturalNumber) {
      user {
        id
        pendingTransferCount
        pendingTransfers(limit: $limit, offset: $offset) {
          id
          recipient {
            id
            profileIconColor
            name
            email
          }
          sender {
            id
            name
          }
          collection {
            id
            name
          }
        }
      }
    }
  `,
  {
    name: "pendingTransfersData",
    options: { variables: { offset: 0, limit: 20 } },
  }
)(
  graphql(
    gql`
      mutation AcceptPendingTransfer($id: ID!) {
        acceptPendingTransfer(id: $id) {
          id
        }
      }
    `,
    {
      name: "AcceptPendingTransfer",
    }
  )(
    graphql(
      gql`
        mutation declinePendingTransfer($id: ID!) {
          declinePendingTransfer(id: $id)
        }
      `,
      {
        name: "DeclinePendingTransfer",
      }
    )(
      class PendingTransfersDialogContent extends Component {
        constructor(props) {
          super(props);

          this.state = {
            fetchMoreLoading: false,
          };
        }

        AcceptPendingTransfer = (id) =>
          this.props.AcceptPendingTransfer({
            variables: {
              id,
            },
            optimisticResponse: {
              __typename: "Mutation",
              pendingTransfers: {
                id,
                __typename: "PendingTransfers",
              },
            },
          });

        DeclinePendingTransfer = (id) =>
          this.props.DeclinePendingTransfer({
            variables: {
              id,
            },
            optimisticResponse: {
              __typename: "Mutation",
              pendingTransfers: {
                id,
                __typename: "PendingTransfers",
              },
            },
          });

        queryMore = async () => {
          if (
            !this.queryMore.locked &&
            this.props.pendingTransfersData.user.pendingTransferCount >
              this.props.pendingTransfersData.user.pendingTransfers.length
          ) {
            this.queryMore.locked = true;

            try {
              this.setState({ fetchMoreLoading: true });
              await this.props.pendingTransfersData.fetchMore({
                variables: {
                  offset:
                    this.props.pendingTransfersData.user.pendingTransfers
                      .length,
                  limit:
                    this.props.pendingTransfersData.user.pendingTransferCount -
                      this.props.pendingTransfersData.user.pendingTransfers
                        .length >=
                    20
                      ? 20
                      : this.props.pendingTransfersData.user
                          .pendingTransferCount % 20,
                },
                updateQuery: (prev, { fetchMoreResult }) => {
                  if (!fetchMoreResult) {
                    return prev;
                  }

                  const newTransfers = [
                    ...prev.user.pendingTransfers,
                    ...fetchMoreResult.user.pendingTransfers,
                  ];

                  return {
                    user: {
                      ...prev.user,
                      pendingTransfers: newTransfers,
                    },
                  };
                },
              });
            } finally {
              this.setState(() => {
                this.queryMore.locked = false;

                return { fetchMoreLoading: false };
              });
            }
          }
        };

        componentDidMount() {
          this.props.pendingTransfersData.refetch();

          this.props.pendingTransfersData.subscribeToMore({
            document: gql`
              subscription {
                pendingTransferCreated {
                  id
                  recipient {
                    id
                    profileIconColor
                    name
                    email
                  }
                  sender {
                    id
                    name
                  }
                  collection {
                    id
                    name
                  }
                }
              }
            `,
            updateQuery: (prev, { subscriptionData }) => {
              if (!subscriptionData.data) {
                return prev;
              }

              const newPendingTransfers = [
                ...prev.user.pendingTransfers,
                subscriptionData.data.pendingTransferCreated,
              ];

              return {
                user: {
                  ...prev.user,
                  pendingTransfers: newPendingTransfers,
                },
              };
            },
          });

          const pendingTransferDeclinedSubscription = gql`
            subscription {
              pendingTransferDeclined
            }
          `;

          this.props.pendingTransfersData.subscribeToMore({
            document: pendingTransferDeclinedSubscription,
            updateQuery: (prev, { subscriptionData }) => {
              if (!subscriptionData.data) {
                return prev;
              }

              const newPendingTransfers = prev.user.pendingTransfers.filter(
                (pendingTransfer) =>
                  pendingTransfer.id !==
                  subscriptionData.data.pendingTransferDeclined
              );

              return {
                user: {
                  ...prev.user,
                  pendingTransfers: newPendingTransfers,
                },
              };
            },
          });

          const pendingTransferRevokedSubscription = gql`
            subscription {
              pendingTransferRevoked
            }
          `;

          this.props.pendingTransfersData.subscribeToMore({
            document: pendingTransferRevokedSubscription,
            updateQuery: (prev, { subscriptionData }) => {
              if (!subscriptionData.data) {
                return prev;
              }

              const newPendingTransfers = prev.user.pendingTransfers.filter(
                (pendingTransfer) =>
                  pendingTransfer.id !==
                  subscriptionData.data.pendingTransferRevoked
              );

              return {
                user: {
                  ...prev.user,
                  pendingTransfers: newPendingTransfers,
                },
              };
            },
          });

          const pendingTransferAcceptedSubscription = gql`
            subscription {
              pendingTransferAccepted {
                id
              }
            }
          `;

          this.props.pendingTransfersData.subscribeToMore({
            document: pendingTransferAcceptedSubscription,
            updateQuery: (prev, { subscriptionData }) => {
              if (!subscriptionData.data) {
                return prev;
              }

              const newPendingTransfers = prev.user.pendingTransfers.filter(
                (pendingTransfer) =>
                  pendingTransfer.id !==
                  subscriptionData.data.pendingTransferAccepted.id
              );

              return {
                user: {
                  ...prev.user,
                  pendingTransfers: newPendingTransfers,
                },
              };
            },
          });
        }

        componentWillReceiveProps(nextProps) {
          if (
            nextProps.pendingTransfersData.user &&
            this.props.pendingTransfersData.user &&
            nextProps.pendingTransfersData.user.pendingTransfers.length !==
              this.props.pendingTransfersData.user.pendingTransfers.length &&
            !nextProps.pendingTransfersData.user.pendingTransfers[0]
          ) {
            this.props.close();
          }
        }

        render() {
          const {
            pendingTransfersData: { error, loading, user, refetch },
            fullScreen,
            unverified,
            t,
          } = this.props;

          const textColor = process.env.REACT_APP_TEXT_ON_MAIN_BACKGROUND_COLOR;

          if (loading)
            dialogContent = (
              <div style={{ height: "100%" }}>
                <CenteredSpinner />
              </div>
            );

          if (error)
            dialogContent = (
              <div style={{ height: "100%" }}>
                <ErrorScreen
                  refetch={() => refetch({ offset: 0, limit: 20 })}
                  error={error}
                />
              </div>
            );

          if (user)
            dialogContent = (
              <DialogContent
                style={{ padding: 0 }}
                onScroll={(event) => {
                  if (
                    event.target.scrollTop + event.target.clientHeight >=
                    event.target.scrollHeight - 600
                  )
                    this.queryMore();
                }}
              >
                <IsOnline
                  onChange={(online) => {
                    if (online) {
                      this.props.pendingTransfersData.refetch();
                    }
                  }}
                />
                <List
                  style={{
                    width: "100%",
                    textOverflow: "ellipsis",
                    padding: 0,
                  }}
                >
                  {user.pendingTransfers.map((pendingTransfer) => (
                    <Collection
                      id={pendingTransfer.collection.id}
                      key={pendingTransfer.collection.id}
                      fields={["name"]}
                    >
                      {({ collectionData }) => (
                        <User
                          id={pendingTransfer.sender.id}
                          fields={["name"]}
                          privateCloud={process.env.REACT_APP_PRIVATE_CLOUD}
                        >
                          {({ userData }) => (
                            <ListItem
                              style={{
                                paddingLeft:
                                  "calc(24px + " +
                                  (fullScreen
                                    ? getNotchHeight("left")
                                    : "0px") +
                                  ")",
                                paddingRight:
                                  "calc(24px + " +
                                  (fullScreen
                                    ? getNotchHeight("right")
                                    : "0px") +
                                  ")",
                              }}
                              key={pendingTransfer.id}
                            >
                              <ListItemText
                                primary={
                                  <font
                                    style={{
                                      color: textColor,
                                    }}
                                  >
                                    {collectionData
                                      ? collectionData.name
                                      : pendingTransfer.collection.name}
                                  </font>
                                }
                                secondary={
                                  <font
                                    style={{
                                      color: tinyColor(textColor)
                                        .setAlpha(0.54)
                                        .toRgbString(),
                                    }}
                                  >
                                    {t`Sent by ` +
                                      (userData
                                        ? userData.name
                                        : pendingTransfer.sender.name)}
                                  </font>
                                }
                                style={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  marginRight: "72px",
                                }}
                              />
                              <ListItemSecondaryAction>
                                <IconButton
                                  onClick={() =>
                                    this.AcceptPendingTransfer(
                                      pendingTransfer.id
                                    )
                                  }
                                  disabled={unverified}
                                  size="large"
                                >
                                  <Done />
                                </IconButton>
                                <IconButton
                                  onClick={() =>
                                    this.DeclinePendingTransfer(
                                      pendingTransfer.id
                                    )
                                  }
                                  size="large"
                                >
                                  <Close />
                                </IconButton>
                              </ListItemSecondaryAction>
                            </ListItem>
                          )}
                        </User>
                      )}
                    </Collection>
                  ))}
                </List>
                {this.state.fetchMoreLoading && <LinearProgress />}
              </DialogContent>
            );

          return dialogContent;
        }
      }
    )
  )
);
